export const PERSONNEL_API_FIELD_MAP = {
  full_name: 'fullName',
  phone: 'phone',
  email: 'email',
  army_type_id: 'armyType',
  department_id: 'armyDepartment',
  sub_department_id: 'subDepartment',
  birth_date: 'birthDate',
  mother_name: 'motherName',
  place_of_birth: 'placeOfBirth',
  rank: 'rank',
  region: 'region',
  district: 'district',
  station: 'station',
  gender: 'gender',
  marital_status: 'maritalStatus',
  educational_level: 'educationalLevel',
  blood_type: 'bloodType',
  status: 'status',
  address: 'address',
  title: 'title',
  organization: 'organization',
  work_place: 'workPlace',
};

export const PERSONNEL_REQUIRED_FIELDS = [
  { key: 'fullName', label: 'Full Name' },
  { key: 'phone', label: 'Phone' },
  { key: 'email', label: 'Email' },
  { key: 'armyType', label: 'Army Type' },
  { key: 'armyDepartment', label: 'Army Department' },
  { key: 'region', label: 'Region' },
  { key: 'district', label: 'District' },
  { key: 'station', label: 'Station' },
  { key: 'rank', label: 'Rank' },
];

const humanize = (key) =>
  key.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').replace(/\b\w/g, (c) => c.toUpperCase());

export function validatePersonnelForm(formData) {
  const fieldErrors = {};
  const messages = [];

  PERSONNEL_REQUIRED_FIELDS.forEach(({ key, label }) => {
    const value = formData[key];
    if (value === undefined || value === null || String(value).trim() === '') {
      const msg = `${label} is required`;
      fieldErrors[key] = msg;
      messages.push(msg);
    }
  });

  if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
    const msg = 'Email is invalid';
    fieldErrors.email = msg;
    if (!messages.includes(msg)) messages.push(msg);
  }

  return { fieldErrors, messages };
}

export function parseApiErrors(data, fieldMap = PERSONNEL_API_FIELD_MAP) {
  const fieldErrors = {};
  const messages = [];

  if (!data) {
    return { fieldErrors, messages: ['Registration failed. Please try again.'] };
  }

  // Unwrap nested data if needed
  const payload = (data.errors || data.error) ? data : (data.data || data);

  // ── 1. Handle structured errors object { field: [messages] } ──────────────
  const errorsObject = payload.errors;
  if (errorsObject && typeof errorsObject === 'object' && !Array.isArray(errorsObject)) {
    Object.entries(errorsObject).forEach(([apiKey, value]) => {
      const msgs = (Array.isArray(value) ? value : [String(value)]).filter(Boolean);
      if (msgs.length === 0) return;

      const formKey = fieldMap[apiKey] || apiKey;
      const combinedMsg = msgs.join(', ');
      fieldErrors[formKey] = combinedMsg;

      msgs.forEach((m) => {
        // If message already starts with a capital letter it's likely self-contained (e.g. "Email has already been taken")
        const text = m.match(/^[A-Z]/) ? m : `${humanize(apiKey)} ${m}`;
        if (!messages.includes(text)) messages.push(text);
      });
    });
  }

  // ── 2. Handle flat error array or string ──────────────────────────────────
  const flatErrors = payload.error
    ? (Array.isArray(payload.error) ? payload.error : [payload.error]).filter(Boolean)
    : [];

  flatErrors.forEach((msg) => {
    const text = String(msg);
    if (!messages.includes(text)) messages.push(text);

    // Try to map the message back to a form field
    Object.entries(fieldMap).some(([apiKey, formKey]) => {
      if (text.toLowerCase().includes(apiKey.replace(/_/g, ' '))) {
        if (!fieldErrors[formKey]) fieldErrors[formKey] = text;
        return true;
      }
      return false;
    });
  });

  // ── 3. Handle top-level message string ───────────────────────────────────
  if (payload.message && messages.length === 0) {
    messages.push(String(payload.message));
  }

  // ── 4. Ultimate fallback ──────────────────────────────────────────────────
  if (messages.length === 0) {
    messages.push(
      typeof payload === 'string'
        ? payload
        : 'Registration failed. Please check your input and try again.'
    );
  }

  return { fieldErrors, messages: [...new Set(messages)] };
}
